export const NAME = "dev";

export default {
  NAME
};
